import { useLocation } from 'react-router';
import PripomienkyListFilter from '../../../model/filter/PripomienkyListFilter';
import stringToDate from '../../../function/stringToDate';
import queryParamToUuidArray from '../function/queryParamToUuidArray';
import queryParamToStringArray from '../function/queryParamToStringArray';
import queryParamToBoolean from '../function/queryParamToBoolean';

export default (): PripomienkyListFilter => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  return {
    text: search.get('text'),
    from: stringToDate(search.get('from')),
    to: stringToDate(search.get('to')),
    typ: queryParamToStringArray(search.get('typ')),
    stav: queryParamToStringArray(search.get('stav')),
    priradeny: queryParamToUuidArray(search.get('priradeny')),
    pripomienkujuciSubjekt: queryParamToUuidArray(search.get('subjekt')),
    isNepriradeny: queryParamToBoolean(search.get('isNepriradeny')),
  };
};
